/**
 * GlobalAlertProvider
 * 
 * React 컴포넌트 외부(SocketProvider 등 static 클래스)에서도 
 * 다이얼로그를 띄울 수 있도록 하는 글로벌 알림 프로바이더.
 * 
 * 사용법:
 *   import GlobalAlertProvider from '@user-provider/GlobalAlertProvider'
 *   GlobalAlertProvider.show('에러 메시지', '제목(선택)')
 *   GlobalAlertProvider.show('에러 메시지', '제목', () => { // 확인 후 콜백 })
 */
export default class GlobalAlertProvider {

    // React 컴포넌트에서 등록할 콜백
    static _showDialog = null

    // 다이얼로그 마운트 전에 호출된 메시지 대기열
    static _pendingQueue = []

    /**
     * React 컴포넌트(GlobalAlertDialog)에서 호출하여 콜백을 등록합니다.
     * @param {Function} showFn - (message, title, onConfirm) => void
     */
    static register(showFn) {
        this._showDialog = showFn

        // 대기열에 쌓인 메시지가 있으면 표시
        if (this._pendingQueue.length > 0) {
            const pending = this._pendingQueue.shift()
            this._showDialog(pending.message, pending.title, pending.onConfirm)
        }
    }

    /**
     * 등록된 콜백을 해제합니다.
     */
    static unregister() {
        this._showDialog = null
    }

    /**
     * 글로벌 다이얼로그를 표시합니다.
     * @param {string} message - 표시할 메시지
     * @param {string} [title='알림'] - 다이얼로그 제목
     * @param {Function} [onConfirm=null] - 확인 버튼 클릭 시 콜백
     */
    static show(message, title = '알림', onConfirm = null) {
        if (this._showDialog) {
            this._showDialog(message, title, onConfirm)
        } else {
            // 다이얼로그가 아직 마운트되지 않은 경우 대기열에 저장
            this._pendingQueue.push({ message, title, onConfirm })
        }
    }
}
